module.exports = __webpack_public_path__ + "static/vps-hosting-84023c18e6d5a6457613271258a8d4d8.png";